import slide from "../../images/img/slide.jpg";
import maindish from "../../images/img/maindish.jpg";
import breakfast from "../../images/img/breakfast.jpg";

export const images = [
  {
    id: 2,
    image: slide,
    text: "",
  },
  {
    id: 1,
    image: maindish,
    text: "",
  },
  {
    id: 3,
    image: breakfast,
    text: "",
  },
];
